import PropTypes from 'prop-types';
import DeliverableDatePropType
from '../sections/DeliveryOptionSection/DeliveryOptionNamedDays/DeliverableDate.proptype';
import DeliveryOptionPricePropType from './DeliveryOptionPrice.proptype';
import StoreInfoPropType from '../sections/DeliveryOptionSection/DeliveryOptioStoreInformation/storeInfo.proptype';

export default {
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  translationKeys: PropTypes.number,
  price: DeliveryOptionPricePropType,
  discountedPrice: DeliveryOptionPricePropType,
  taxPrice: DeliveryOptionPricePropType,
  minimumDeliveryDays: PropTypes.number,
  maximumDeliveryDays: PropTypes.number,
  taxable: PropTypes.bool,
  fastDelivery: PropTypes.bool,
  residentIdRequired: PropTypes.bool,
  loyaltyOfferType: PropTypes.object,
  deliverableDates: PropTypes.arrayOf(PropTypes.shape(DeliverableDatePropType).isRequired).isRequired,
  selectedDeliverableDateIndex: PropTypes.number.isRequired,
  store: PropTypes.shape(StoreInfoPropType),
};
